import { asInlineSVG } from '../../components/InlineSvg';
import InsertEmoteIconSvg from '../../../assets/da-editor/plugins/emote/insert-emote-icon.inline.svg';
var InsertEmoteIcon = asInlineSVG(InsertEmoteIconSvg);
export { InsertEmoteIcon };
//# sourceMappingURL=icons.js.map